import { TenantPersonaConfig } from "@oneethos/shared"
import { PasswordInput, TextInput } from "../forms"

type PersonaFormProps = {
  config: TenantPersonaConfig
  setPersonaConfig: (c: Partial<TenantPersonaConfig>) => void
}

export const PersonaForm = ({ config, setPersonaConfig }: PersonaFormProps) => {
  return <div>
    <h4>Persona</h4>
    <div className="form-group">
      <label>Persona API Key</label>
      <PasswordInput
        value={config?.apiKey}
        onChange={val => setPersonaConfig({ apiKey: val })}
      />
    </div>

    <div className="form-group">
      <label>Persona Inquiry Template ID</label>
      <TextInput
        value={config?.templateId || ''}
        onChange={val => setPersonaConfig({ templateId: val })}
      />
    </div>

    <div className="form-group">
      <label>Persona Webhook Secret</label>
      <PasswordInput
        value={config?.webhookSecret}
        onChange={val => setPersonaConfig({ webhookSecret: val })}
      />
    </div>

    <div className="form-group">
      <label>Persona API Version</label>
      <TextInput
        value={config?.apiVersion || ''}
        onChange={val => setPersonaConfig({ apiVersion: val })}
      />
    </div>
  </div>
}
